import React from 'react';
import { style } from 'typestyle';
import { center, flexRoot, vertical } from 'csstips';
import { px } from 'csx';
import { colorWhite, rebrand } from '../../../../theme/color';
import { Skeleton } from '../../atoms/Skeleton';

const styles = {
  wrapper: style(flexRoot, center, {
    backgroundColor: colorWhite.toHexString(),
    padding: `${px(6)} ${px(12)}`,
    borderTop: `solid 1px ${rebrand.neutralOnDark[20]}`,
    maxHeight: px(48),
  }),
  entityWrapper: style(vertical, {
    paddingLeft: px(8),
    gap: px(4),
  }),
};

/** Placeholder when search suggestions are loading */
export const SearchSuggestionSkeleton: React.FC = () => {
  return (
    <div className={styles.wrapper} data-test-search-suggestion-loader>
      <Skeleton height={24} width={24} />
      <div className={styles.entityWrapper}>
        <Skeleton height={20} width={120} />
        <Skeleton height={12} width={50} />
      </div>
    </div>
  );
};
